import "./index.esm.css"
import { ref, watch, resolveComponent, openBlock, createBlock, Transition, withCtx, createElementBlock, createElementVNode, withModifiers, toDisplayString, createCommentVNode, createTextVNode, renderSlot, Fragment, renderList, normalizeStyle, withDirectives, vModelCheckbox } from 'vue';
import { Select } from 'ant-design-vue';

const ModalMaker = () => {
    const valueHolder = ref({});
    const htmlHolder = ref('');
    const show = ref(false);
    const image = ref('');
    const showCancel = ref(false);
    const showConfirm = ref(true);
    const showPrompt = ref(false);
    const showOptions = ref(false);
    const promptValue = ref("");
    const confirm = ref(() => {
    });
    const cancel = ref(() => {
    });
    const optionArray = ref([]);
    const optionValues = ref({});
    const resetModal = () => {
        valueHolder.value = {};
        htmlHolder.value = '';
        show.value = false;
        image.value = '';
        showCancel.value = false;
        showConfirm.value = true;
        showPrompt.value = false;
        showOptions.value = false;
        promptValue.value = '';
        confirm.value = () => { };
        cancel.value = () => { };
        optionArray.value = [];
        optionValues.value = {};
    };
    const display = (str, img, cb1, cb2) => {
        showLoading.value = false;
        valueHolder.value.title = str;
        image.value = img;
        show.value = true;
        handleCb(cb1, cb2);
    };
    const alert = (str, cb1, cb2) => {
        showLoading.value = false;
        valueHolder.value.title = str;
        show.value = true;
        handleCb(cb1, cb2);
    };
    const html = (str, cb1, cb2) => {
        showLoading.value = false;
        htmlHolder.value = str;
        show.value = true;
        handleCb(cb1, cb2);
    };
    const query = (str, cb1, cb2) => {
        showLoading.value = false;
        valueHolder.value.title = str;
        show.value = true;
        showCancel.value = true;
        showConfirm.value = true;
        handleCb(cb1, cb2);
    };
    const prompt = (str, cb1, cb2) => {
        showLoading.value = false;
        valueHolder.value.title = str;
        show.value = true;
        showPrompt.value = true;
        showCancel.value = true;
        showConfirm.value = true;
        confirm.value = () => {
            cb1(promptValue.value);
            resetModal();
        };
        if (cb2) {
            cancel.value = () => {
                cb2();
                resetModal();
            };
        }
        else {
            cancel.value = () => {
                resetModal();
            };
        }
    };
    const options = (ops) => {
        showLoading.value = false;
        valueHolder.value.title = ops.title;
        show.value = true;
        showOptions.value = true;
        showCancel.value = true;
        showConfirm.value = true;
        optionArray.value = ops.fields;
        confirm.value = () => {
            if (typeof ops.onConfirm == 'function') {
                ops.onConfirm(optionValues.value);
            }
            resetModal();
        };
        cancel.value = () => {
            if (typeof ops.onCancel == 'function') {
                ops.onCancel(promptValue.value);
            }
            resetModal();
        };
    };
    const showLoading = ref(false);
    const loadOn = (str) => {
        resetModal();
        showLoading.value = true;
        valueHolder.value.title = str || "请稍候...";
        show.value = true;
    };
    const loadOff = () => {
        resetModal();
        showLoading.value = false;
        show.value = false;
        image.value = '';
    };
    const handleCb = (cb1, cb2) => {
        if (cb1) {
            confirm.value = () => {
                show.value = false;
                cb1();
                showCancel.value = false;
                resetModal();
            };
            if (cb2) {
                cancel.value = () => {
                    show.value = false;
                    cb2();
                    showCancel.value = false;
                    resetModal();
                };
            }
            else {
                cancel.value = () => {
                    show.value = false;
                    showCancel.value = false;
                    resetModal();
                };
            }
        }
        else {
            confirm.value = () => resetModal();
            cancel.value = () => resetModal();
        }
    };
    return {
        html,
        htmlHolder,
        valueHolder,
        show,
        showCancel,
        showConfirm,
        showPrompt,
        showLoading,
        options,
        optionValues,
        optionArray,
        showOptions,
        promptValue,
        confirm,
        cancel,
        image,
        alert,
        query,
        prompt,
        display,
        loadOn,
        loadOff
    };
};

const modal = ModalMaker();

const en = {
    '确定': "OK",
    '取消': 'Cancel',
    '是': 'Yes',
    '否': 'No',
    '点击输入': 'Click to enter',
    '点击选择': 'Click to select',
};
const i18n = (text) => {
    //@ts-ignore
    var userLang = navigator.language || navigator.userLanguage;
    console.log("The language is: " + userLang);
    if (userLang.match(/^zh/)) {
        // return en[text] || text
        return text;
    }
    else {
        return en[text] || text;
    }
};

var script = {
    name: "Modal",
    components: {
        Select
    },
    props: {},
    setup(props, { emit }) {
        const onClickConfirm = () => {
            let intercepted = false;
            for (let i = 0; i < modal.optionArray.value.length; i++) {
                if (modal.optionArray.value[i].show_if
                    && !modal.optionArray.value[i].show_if(modal.optionValues.value)) {
                    continue;
                }
                if (modal.optionArray.value[i].required) {
                    const key = modal.optionArray.value[i].key;
                    if (!modal.optionValues.value[key]) {
                        intercepted = true;
                        optionAlerts.value[i] = '该项为必填项！';
                    }
                }
                if (typeof modal.optionArray.value[i].check == "function") {
                    const checkString = modal.optionArray.value[i].check(modal.optionValues.value);
                    if (checkString) {
                        intercepted = true;
                        optionAlerts.value[i] = checkString;
                    }
                }
            }
            if (!intercepted) {
                modal.confirm.value();
            }
        };
        const onClickCancel = () => {
            modal.cancel.value();
        };
        const handlePromptInput = (e) => {
            modal.promptValue.value = e.target.value;
        };
        // options
        const optionAlerts = ref({});
        const resetAlerts = () => {
            for (let i = 0; i < modal.optionArray.value.length; i++) {
                optionAlerts[i] = '';
            }
        };
        watch(() => modal.optionArray.value, () => {
            resetAlerts();
            for (let i = 0; i < modal.optionArray.value.length; i++) {
                const field = modal.optionArray.value[i];
                const key = field.key;
                // console.log('field', field)
                if (['tags', 'multiple'].includes(field.type)) {
                    modal.optionValues.value[key] = field.defaultValue || [];
                }
                else {
                    modal.optionValues.value[key] = field.defaultValue || undefined;
                }
                // console.log('modal.optionValues.value', modal.optionValues.value)
            }
        });
        const handleOptionInput = (key, e) => {
            modal.optionValues.value[key] = e.target.value;
        };
        const handleOptionUpload = (key, e) => {
            if (e.target.files) {
                modal.optionValues.value[key] = e.target.files;
            }
        };
        const onClickInput = (e) => {
        };
        const handleOptionSelect = (key, e) => {
            modal.optionValues.value[key] = e;
        };
        const autoCompleteOptions = ref({});
        const handleAutoCompleteSearch = (ind, key, e) => {
            const foundColumn = modal.optionArray.value[ind];
            console.log("foundCOlumn", foundColumn, e, foundColumn.options.filter(x => x.value.includes(e)));
            if (!foundColumn) {
                return;
            }
            if (!foundColumn.options) {
                return;
            }
            autoCompleteOptions.value[key] = foundColumn.options.filter(x => x.value.includes(e));
            console.log('autoCompleteOptions', ind, autoCompleteOptions.value);
            modal.optionValues.value[key] = e;
        };
        const handleAutoCompleteSelect = (key, e) => {
            modal.optionValues.value[key] = e;
        };
        // watch(
        //     () =>  ({...modal.optionArray.value, ...modal.optionValues.value}), 
        //     ()=>{
        //         for(let i = 0; i < modal.optionArray.value.length; i++){
        //             const column = modal.optionArray.value[i]
        //             if(column.type != "autoComplete") continue
        //             if(!column.options) continue
        //             // autoCompleteOptions.value[i] = column.options
        //         }
        //     },
        //     {deep:true}
        // )
        const handleCheckBoxChange = (key, e) => {
            modal.optionValues.value[key] = !modal.optionValues.value[key];
        };
        return {
            i18n,
            onClickConfirm,
            onClickCancel,
            onClickInput,
            handlePromptInput,
            modal,
            optionAlerts,
            handleOptionInput,
            handleOptionUpload,
            handleOptionSelect,
            handleAutoCompleteSearch,
            handleAutoCompleteSelect,
            autoCompleteOptions,
            handleCheckBoxChange
        };
    }
};

const _hoisted_1 = {
  key: 0,
  class: "__modal_card"
};
const _hoisted_2 = { class: "__modal_card_title" };
const _hoisted_3 = {
  key: 0,
  class: "__modal_card_content"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 2,
  class: "__modal_card_content"
};
const _hoisted_6 = {
  key: 3,
  class: "__modal_card_content __modal_card_options"
};
const _hoisted_7 = {
  key: 0,
  class: "option_item_wrap"
};
const _hoisted_8 = { class: "option_key" };
const _hoisted_9 = { class: "option_input" };
const _hoisted_10 = ["defaultValue", "placeholder", "onInput"];
const _hoisted_11 = ["accept", "onChange"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = /*#__PURE__*/createTextVNode("   ");
const _hoisted_15 = ["defaultValue", "onUpdate:modelValue"];
const _hoisted_16 = {
  key: 0,
  class: "option_alert"
};
const _hoisted_17 = {
  key: 4,
  class: "__modal_loading_container"
};
const _hoisted_18 = /*#__PURE__*/createElementVNode("img", {
  src: "https://huamei2001.oss-cn-shenzhen.aliyuncs.com/icons/loading.gif",
  alt: ""
}, null, -1 /* HOISTED */);
const _hoisted_19 = [
  _hoisted_18
];
const _hoisted_20 = { class: "__modal_card_buttons" };

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_cascader = resolveComponent("a-cascader");
  const _component_a_select_option = resolveComponent("a-select-option");
  const _component_a_select = resolveComponent("a-select");
  const _component_a_auto_complete = resolveComponent("a-auto-complete");

  return (openBlock(), createBlock(Transition, { name: "fade" }, {
    default: withCtx(() => [
      ($setup.modal && $setup.modal.show && $setup.modal.show.value)
        ? (openBlock(), createElementBlock("div", _hoisted_1, [
            createElementVNode("div", {
              class: "__modal_card_body",
              onClick: _cache[4] || (_cache[4] = withModifiers(() => {}, ["stop"]))
            }, [
              createElementVNode("div", _hoisted_2, toDisplayString($setup.modal.valueHolder.value.title), 1 /* TEXT */),
              createCommentVNode(" display text "),
              ($setup.modal.valueHolder.value.content 
                    && $setup.modal.valueHolder.value.content.length>0)
                ? (openBlock(), createElementBlock("div", _hoisted_3, [
                    createTextVNode(toDisplayString($setup.modal.valueHolder.value.content) + " ", 1 /* TEXT */),
                    renderSlot(_ctx.$slots, "default")
                  ]))
                : createCommentVNode("v-if", true),
              createCommentVNode(" display text "),
              ($setup.modal.htmlHolder.value)
                ? (openBlock(), createElementBlock("div", {
                    key: 1,
                    class: "__modal_card_content",
                    innerHTML: $setup.modal.htmlHolder.value
                  }, null, 8 /* PROPS */, _hoisted_4))
                : createCommentVNode("v-if", true),
              createCommentVNode(" prompt input "),
              ($setup.modal.showPrompt.value)
                ? (openBlock(), createElementBlock("div", _hoisted_5, [
                    createElementVNode("input", {
                      type: "text",
                      class: "__modal_card_prompt_input",
                      onInput: _cache[0] || (_cache[0] = (...args) => ($setup.handlePromptInput && $setup.handlePromptInput(...args)))
                    }, null, 32 /* HYDRATE_EVENTS */)
                  ]))
                : createCommentVNode("v-if", true),
              createCommentVNode(" options input "),
              ($setup.modal.showOptions.value)
                ? (openBlock(), createElementBlock("div", _hoisted_6, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList($setup.modal.optionArray.value, (item, ind) => {
                      return (openBlock(), createElementBlock("div", {
                        class: "option_item",
                        key: ind
                      }, [
                        (
                            (!item.show_if)
                            || item.show_if($setup.modal.optionValues.value)
                        )
                          ? (openBlock(), createElementBlock("div", _hoisted_7, [
                              createElementVNode("div", _hoisted_8, toDisplayString(item.prompt), 1 /* TEXT */),
                              createElementVNode("div", _hoisted_9, [
                                (['text', 'input'].includes(item.type))
                                  ? (openBlock(), createElementBlock("input", {
                                      key: 0,
                                      type: "text",
                                      style: normalizeStyle(item.style),
                                      defaultValue: item.defaultValue||'',
                                      placeholder: item.placeholder||'',
                                      class: "__modal_card_prompt_input",
                                      onInput: e=>$setup.handleOptionInput(item.key, e)
                                    }, null, 44 /* STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_10))
                                  : createCommentVNode("v-if", true),
                                createCommentVNode(" <input type=\"text\"> "),
                                (item.type=='upload')
                                  ? (openBlock(), createElementBlock("input", {
                                      key: 1,
                                      type: "file",
                                      class: "__modal_card_prompt_input",
                                      multiple: true,
                                      accept: item.accept || 'image/png, image/jpeg, .pdf, .xlsx',
                                      onClick: _cache[1] || (_cache[1] = (...args) => ($setup.onClickInput && $setup.onClickInput(...args))),
                                      onChange: e=>$setup.handleOptionUpload(item.key, e)
                                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11))
                                  : createCommentVNode("v-if", true),
                                (item.type=='upload')
                                  ? (openBlock(), createElementBlock("div", {
                                      key: 2,
                                      class: "uploadFiles",
                                      style: normalizeStyle(item.style)
                                    }, [
                                      (openBlock(true), createElementBlock(Fragment, null, renderList($setup.modal.optionValues.value[item.key] || [], (i, iind) => {
                                        return (openBlock(), createElementBlock("div", {
                                          class: "uploadFile",
                                          key: iind
                                        }, toDisplayString(i.name), 1 /* TEXT */))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ], 4 /* STYLE */))
                                  : createCommentVNode("v-if", true),
                                (item.type=='callback')
                                  ? (openBlock(), createElementBlock("div", {
                                      key: 3,
                                      style: normalizeStyle(item.style),
                                      class: "__modal_card_prompt_callback",
                                      accept: "image/png, image/jpeg, .pdf, .xlsx ",
                                      onClick: item.cb
                                    }, " 点击下载 ", 12 /* STYLE, PROPS */, _hoisted_12))
                                  : createCommentVNode("v-if", true),
                                (item.type=='cascader')
                                  ? (openBlock(), createBlock(_component_a_cascader, {
                                      key: 4,
                                      class: "__modal_card_prompt_",
                                      options: item.options||'',
                                      defaultValue: item.defaultValue||'',
                                      placeholder: item.placeholder || $setup.i18n('点击选择'),
                                      getPopupContainer: triggerNode => triggerNode.parentNode,
                                      value: $setup.modal.optionValues.value[item.key] || '',
                                      listHeight: 120,
                                      onChange: e=>$setup.handleOptionSelect(item.key, e)
                                    }, null, 8 /* PROPS */, ["options", "defaultValue", "placeholder", "getPopupContainer", "value", "onChange"]))
                                  : createCommentVNode("v-if", true),
                                (item.type=='select')
                                  ? (openBlock(), createBlock(_component_a_select, {
                                      key: 5,
                                      class: "__modal_card_prompt_",
                                      defaultValue: item.defaultValue||'',
                                      placeholder: item.placeholder || $setup.i18n('点击选择'),
                                      getPopupContainer: triggerNode => triggerNode.parentNode,
                                      value: $setup.modal.optionValues.value[item.key] || '',
                                      "show-search": "",
                                      listHeight: 120,
                                      onChange: e=>$setup.handleOptionSelect(item.key, e)
                                    }, {
                                      default: withCtx(() => [
                                        (openBlock(true), createElementBlock(Fragment, null, renderList(item.options, (o, oind) => {
                                          return (openBlock(), createBlock(_component_a_select_option, {
                                            key: oind,
                                            value: o.value
                                          }, {
                                            default: withCtx(() => [
                                              createTextVNode(toDisplayString(o.display), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["defaultValue", "placeholder", "getPopupContainer", "value", "onChange"]))
                                  : createCommentVNode("v-if", true),
                                (item.type=='tags')
                                  ? (openBlock(), createBlock(_component_a_select, {
                                      key: 6,
                                      class: "__modal_card_prompt_",
                                      mode: "tags",
                                      placeholder: item.placeholder || $setup.i18n('点击选择'),
                                      defaultValue: item.defaultValue||[],
                                      getPopupContainer: triggerNode => triggerNode.parentNode,
                                      value: $setup.modal.optionValues.value[item.key] || '',
                                      listHeight: 120,
                                      onChange: e=>$setup.handleOptionSelect(item.key, e)
                                    }, {
                                      default: withCtx(() => [
                                        (openBlock(true), createElementBlock(Fragment, null, renderList(item.options, (o, oind) => {
                                          return (openBlock(), createBlock(_component_a_select_option, {
                                            key: oind,
                                            value: o.value
                                          }, {
                                            default: withCtx(() => [
                                              createTextVNode(toDisplayString(o.display), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["placeholder", "defaultValue", "getPopupContainer", "value", "onChange"]))
                                  : createCommentVNode("v-if", true),
                                (item.type=='multiple')
                                  ? (openBlock(), createBlock(_component_a_select, {
                                      key: 7,
                                      class: "__modal_card_prompt_",
                                      mode: "multiple",
                                      placeholder: item.placeholder || $setup.i18n('点击选择'),
                                      defaultValue: item.defaultValue||[],
                                      getPopupContainer: triggerNode => triggerNode.parentNode,
                                      value: $setup.modal.optionValues.value[item.key] || '',
                                      listHeight: 120,
                                      onChange: e=>$setup.handleOptionSelect(item.key, e)
                                    }, {
                                      default: withCtx(() => [
                                        (openBlock(true), createElementBlock(Fragment, null, renderList(item.options, (o, oind) => {
                                          return (openBlock(), createBlock(_component_a_select_option, {
                                            key: oind,
                                            value: o.value
                                          }, {
                                            default: withCtx(() => [
                                              createTextVNode(toDisplayString(o.display), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["placeholder", "defaultValue", "getPopupContainer", "value", "onChange"]))
                                  : createCommentVNode("v-if", true),
                                createCommentVNode(" {{ modal.optionValues.value }}{{ item.key }}\n                            "),
                                createCommentVNode(" {{ autoCompleteOptions[item.key] }}{{ ind }}  "),
                                (item.type=='autoComplete')
                                  ? (openBlock(), createBlock(_component_a_auto_complete, {
                                      key: 8,
                                      class: "__modal_card_prompt_",
                                      placeholder: item.placeholder || $setup.i18n('点击输入'),
                                      defaultValue: item.defaultValue||[],
                                      getPopupContainer: triggerNode => triggerNode.parentNode,
                                      value: $setup.modal.optionValues.value[item.key] || '',
                                      options: $setup.autoCompleteOptions[item.key],
                                      listHeight: 120,
                                      onSearch: e=>$setup.handleAutoCompleteSearch(ind, item.key, e),
                                      onSelect: e=>$setup.handleAutoCompleteSelect(item.key, e)
                                    }, null, 8 /* PROPS */, ["placeholder", "defaultValue", "getPopupContainer", "value", "options", "onSearch", "onSelect"]))
                                  : createCommentVNode("v-if", true),
                                (item.type=='checkbox')
                                  ? (openBlock(), createElementBlock("div", {
                                      key: 9,
                                      style: normalizeStyle(item.style),
                                      class: "__modal_card_prompt_callback",
                                      onClick: withModifiers(e=>$setup.handleCheckBoxChange(item.key,e), ["stop"])
                                    }, [
                                      _hoisted_14,
                                      withDirectives(createElementVNode("input", {
                                        type: "checkbox",
                                        defaultValue: item.defaultValue||false,
                                        "onUpdate:modelValue": $event => (($setup.modal.optionValues.value[item.key]) = $event)
                                      }, null, 8 /* PROPS */, _hoisted_15), [
                                        [vModelCheckbox, $setup.modal.optionValues.value[item.key]]
                                      ]),
                                      createTextVNode("  " + toDisplayString(!!$setup.modal.optionValues.value[item.key] ?  $setup.i18n('是') : $setup.i18n('否')), 1 /* TEXT */)
                                    ], 12 /* STYLE, PROPS */, _hoisted_13))
                                  : createCommentVNode("v-if", true)
                              ]),
                              ($setup.optionAlerts[ind])
                                ? (openBlock(), createElementBlock("div", _hoisted_16, toDisplayString($setup.optionAlerts[ind]), 1 /* TEXT */))
                                : createCommentVNode("v-if", true)
                            ]))
                          : createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : createCommentVNode("v-if", true),
              ($setup.modal.showLoading.value)
                ? (openBlock(), createElementBlock("div", _hoisted_17, _hoisted_19))
                : createCommentVNode("v-if", true),
              createElementVNode("div", _hoisted_20, [
                ($setup.modal.showConfirm)
                  ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: "__modal_card_button",
                      onClick: _cache[2] || (_cache[2] = withModifiers((...args) => ($setup.onClickConfirm && $setup.onClickConfirm(...args)), ["stop","prevent"]))
                    }, toDisplayString($setup.i18n('确定')), 1 /* TEXT */))
                  : createCommentVNode("v-if", true),
                ($setup.modal.showCancel)
                  ? (openBlock(), createElementBlock("div", {
                      key: 1,
                      class: "__modal_card_button",
                      onClick: _cache[3] || (_cache[3] = withModifiers((...args) => ($setup.onClickCancel && $setup.onClickCancel(...args)), ["stop","prevent"]))
                    }, toDisplayString($setup.i18n('取消')), 1 /* TEXT */))
                  : createCommentVNode("v-if", true)
              ])
            ])
          ]))
        : createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }))
}

script.render = render;
script.__file = "src/Component.vue";

const components = { Component: script };
const plugin = {
    install(Vue) {
        Vue.provide("modal", modal);
        for (const prop in components) {
            if (components.hasOwnProperty(prop)) {
                //@ts-ignore
                const component = components[prop];
                Vue.component(component.name, component);
            }
        }
        // nextTick(()=>{
        //     const mountEl = document.createElement('div');
        //     mountEl.id="modal_mountel"
        //     document.body.appendChild(mountEl);
        //     console.log("mountEl", mountEl);
        //     const comp = createApp({ extends: Component }, {
        //         // props
        //         modal,
        //         // events are passed as props here with on[EventName]
        //         onClose() {
        //             mountEl.parentNode.removeChild(mountEl);
        //             comp.unmount();
        //         },
        //     });
        //     console.log(comp)
        //     comp.mount(mountEl);
        // })
    }
};

export { script as Component, plugin as default, modal };
